import React, { useState } from 'react';
import PropTypes from 'prop-types';
import '../../App.css';

function ContactCard({
    icon,
    label,
    content,
    onClick,
    role,
    tabIndex,
    cardHoverColor
}) {
    const [borderColor, setBorderColor] = useState('rgba(255, 215, 0, 0.3)');

    const handleMouseEnter = () => {
        if (cardHoverColor) {
            setBorderColor(cardHoverColor);
        } else {
            setBorderColor('#ffd700');
        }
    };

    const handleMouseLeave = () => {
        setBorderColor('rgba(255, 215, 0, 0.3)');
    };

    return (
        <div
            className="card" // Use class name as string
            style={{ borderColor }}
            onClick={onClick}
            role={role}
            tabIndex={tabIndex}
            onKeyDown={onClick ? (e) => e.key === 'Enter' && onClick() : undefined}
            onMouseEnter={onClick ? handleMouseEnter : undefined}
            onMouseLeave={onClick ? handleMouseLeave : undefined}
        >
            <div className="icon">{icon}</div> 
            <div className="fb-type-desc"> 
                <div className="label">{label}</div> 
                {content}
            </div>
        </div>
    );
}

ContactCard.propTypes = {
    icon: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    label: PropTypes.string.isRequired,
    content: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    onClick: PropTypes.func,
    role: PropTypes.string,
    tabIndex: PropTypes.number,
    cardHoverColor: PropTypes.string,
};

ContactCard.defaultProps = {
    onClick: undefined,
    role: undefined,
    tabIndex: undefined,
    cardHoverColor: undefined,
};

export default ContactCard;